import usePresentPage from 'client/hooks/usePresentPage'
import { getPageType } from 'client/reducers/pageReducer'
import { usePage } from 'client/store'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import { EntitiesStructure } from 'common/types/Page'
import { useMemo } from 'react'
import { diagnosticRules } from 'src/editor/diagnostics/consts'
import { DiagnosticFinding } from '../types'

export const runDiagnostics = (
  entities: EntitiesStructure,
  pageType: PageTypeEnum,
): DiagnosticFinding[] => {
  const findings: DiagnosticFinding[] = []

  for (const rule of diagnosticRules) {
    try {
      findings.push(...rule.run(entities, pageType))
    } catch {
      // Tolerate rule failures without crashing the editor
    }
  }

  return findings
}

export const useDiagnostics = (): DiagnosticFinding[] => {
  const entities = usePage(page => page.entities)
  const pageType = usePresentPage(getPageType)

  return useMemo(() => runDiagnostics(entities, pageType), [entities, pageType])
}
